module.exports = {
    catalogUrl: 'https://stac.geoplatform.gov/catalog.json',
    catalogTitle: "GeoPlatform STAC",
    catalogImage: null,
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
        "ar",
//      "de-CH",
        "es",
        "en",
        "fr",
//      "fr-CA",
//      "fr-CH",
        "it",
//      "it-CH",
        "ro",
        "ja",
        "pt",
        "id",
        "pl"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    displayGeoTiffByDefault: false,
    displayPreview: true,
    displayOverview: true,
    buildTileUrlTemplate: null,
    getMapSourceOptions: null,
    pathPrefix: "/",
    historyMode: "hash",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showThumbnailsAsAssets: false,
    showKeywordsInItemCards: true,
    showKeywordsInCatalogCards: true,
    itemsPerPage: 12,
    searchResultsPerPage: null,
    collectionsPerPage: null,
    maxEntriesPerPage: 1000,
    defaultThumbnailSize: null,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    socialSharing: ['email', 'bsky', 'mastodon', 'x'],
    crs: {},
    footerLinks: null,
    authConfig: null,
    preprocessSTAC: (() => {
        const stacMetadata = {
            '/external/stac.asf.alaska.edu/': {
                title: 'Alaska Satellite Facility',
                description: 'The Alaska Satellite Facility is part of the Geophysical Institute of the University of Alaska Fairbanks, located on the Troth Yeddha’ campus.'
            },
            '/external/landsatlook.usgs.gov/stac-server/': {
                title: 'USGS Landsat Collection 2 data',
                description: 'LandsatLook is a tool that allows rapid online viewing and access to the USGS Landsat Collection 2 data. LandsatLook leverages resources available via a commercial cloud environment including Cloud Optimized GeoTIFF (COG) and Spatio Temporal Asset Catalog (STAC) metadata.'
            },
            '/external/api.waterdata.usgs.gov/ogcapi/v0/': { title: 'USGS Water Data' },
            '/external/hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri ArcGIS Hub' },
            '/external/data-algeohub.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Alabama' },
            '/external/gis.data.alaska.gov/api/search/v1/collections/all': { title: 'Alaska' },
            '/external/azgeo-data-hub-agic.hub.arcgis.com/api/search/v1/collections/all': { title: 'Arizona' },
            '/external/gis.data.ca.gov/api/search/v1/collections/all': { title: 'California' },
            '/external/ct-deep-gis-open-data-website-ctdeep.hub.arcgis.com/api/search/v1/collections/all': { title: 'Connecticut' },
            '/external/geodata.floridagio.gov/api/search/v1/collections/all': { title: 'Florida' },
            '/external/data-hub.gio.georgia.gov/api/search/v1/collections/all': { title: 'Georgia' },
            '/external/geoportal.hawaii.gov/api/search/v1/collections/all': { title: 'Hawaii' },
            '/external/gis-idaho.hub.arcgis.com/api/search/v1/collections/all': { title: 'Idaho' },
            '/external/www.indianamap.org/api/search/v1/collections/all': { title: 'Indiana' },
            '/external/data.imap.maryland.gov/api/search/v1/collections/all': { title: 'Maryland' },
            '/external/gis-michigan.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Michigan' },
            '/external/opendata.gis.ms.gov/api/search/v1/collections/all': { title: 'Mississippi' },
            '/external/data-msdis.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Missouri' },
            '/external/map-nebraska.hub.arcgis.com/api/search/v1/collections/all': { title: 'Nebraska' },
            '/external/www.nhgeodata.unh.edu/api/search/v1/collections/all': { title: 'New Hampshire' },
            '/external/data-nmenv.opendata.arcgis.com/api/search/v1/collections/all': { title: 'New Mexico' },
            '/external/data.gis.ny.gov/api/search/v1/collections/all': { title: 'New York' },
            '/external/www.nconemap.gov/api/search/v1/collections/all': { title: 'North Carolina' },
            '/external/gishubdata-ndgov.hub.arcgis.com/api/search/v1/collections/all': { title: 'North Dakota' },
            '/external/csagis-uok.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Oklahoma' },
            '/external/geohub.oregon.gov/api/search/v1/collections/all': { title: 'Oregon' },
            '/external/www.rigis.org/api/search/v1/collections/all': { title: 'Rhode Island' },
            '/external/data-scdnr.opendata.arcgis.com/api/search/v1/collections/all': { title: 'South Carolina' },
            '/external/opendata2017-09-18t192802468z-sdbit.opendata.arcgis.com/api/search/v1/collections/all': { title: 'South Dakota' },
            '/external/tn-tnmap.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Tennessee' },
            '/external/data.texas.gov/api/search/v1/collections/all': { title: 'Texas' },
            '/external/geodata.vermont.gov/api/search/v1/collections/all': { title: 'Vermont' },
            '/external/geo.wa.gov/api/search/v1/collections/all': { title: 'Washington' },
            '/external/wvgis.wvu.edu/data/data.php/api/search/v1/collections/all': { title: 'West Virginia' },
            '/external/data-wi-dnr.opendata.arcgis.com/api/search/v1/collections/all': { title: 'Wisconsin' },
            '/external/data.geospatialhub.org/api/search/v1/collections/all': { title: 'Wyoming' },
            '/external/ngda-address-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Address' },
            '/external/ngda-biodiversity-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Biodiversity and Ecosystems' },
            '/external/ngda-cadastre-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Cadastre' },
            '/external/ngda-climate-and-weather-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Climate and Weather' },
            '/external/ngda-cultural-resources-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Cultural Resources' },
            '/external/ngda-elevation-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Elevation' },
            '/external/ngda-geodetic-control-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Geodetic Control' },
            '/external/ngda-geology-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Geology' },
            '/external/ngda-gov-units-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Governmental Units, and Administrative and Statistical Boundaries' },
            '/external/ngda-imagery-theme-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Imagery' },
            '/external/ngda-international-boundaries-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'International Boundaries' },
            '/external/ngda-land-use-land-cover-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Land Use - Land Cover' },
            '/external/ngda-portfolio-community-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'NGDA Portfolio' },
            '/external/ngda-real-property-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Real Property' },
            '/external/ngda-soils-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Soils' },
            '/external/ngda-transportation-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Transportation' },
            '/external/ngda-utilities-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Utilities' },
            '/external/ngda-water-inland-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Water - Inland' },
            '/external/ngda-water-oceans-and-coasts-geoplatform.hub.arcgis.com/api/search/v1/collections/all': { title: 'Water - Oceans and Coasts' },
            '/external/esri-disasterresponse.hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri Disaster Response' },
            '/external/resilience-fema.hub.arcgis.com/api/search/v1/collections/all': { title: 'FEMA Resilience' },
            '/external/data-napsg.opendata.arcgis.com/api/search/v1/collections/all': { title: 'NAPSG Foundation' },
            '/external/geodata.bts.gov/api/search/v1/collections/all': { title: 'National Transportation Atlas Database' },
            '/external/geospatial-usace.opendata.arcgis.com/api/search/v1/collections/all': {
                title: 'USACE ArcGIS Hub',
                description: "The U.S. Army Corps of Engineers Geospatial Open Data provides shared and trusted USACE geospatial data, services and applications for use by our partner agencies and the public.",
            },
            '/external/oceans-esrioceans.hub.arcgis.com/api/search/v1/collections/all': { title: 'Esri Oceans' },
            '/external/data-sagis.opendata.arcgis.com/api/search/v1/collections/all': { title: 'SAGIS' },
            '/external/epa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'EPA ArcGIS Hub',
                description: "EPA's official ArcGIS Hub providing access to environmental geospatial datasets, maps, and data services for public discovery and use."
            },
            '/external/disasters-geoplatform.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'GeoPlatform Disasters Hub',
                description: 'Whole community geospatial data, tools, and resources for disaster response and resiliency.'
            },
            '/external/resilience-geoplatform.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'GeoPlatform Resilience Hub',
                description: "Here you can find data related to broad environmental change that can help inform and prepare America's communities, businesses, and citizens."
            },
            '/external/disasters-nasa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'NASA Disasters Hub',
                description: 'NASA ArcGIS Online'
            },
            '/external/astrogeology-usgs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USGS Astrogeology' },
            '/external/data-usfs.hub.arcgis.com/api/search/v1/collections/all': { title: 'US Forest Service' },
            '/external/gisforagriculture-usdaocio.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA GIS for Agriculture' },
            '/external/naip-usdaonline.hub.arcgis.com/api/search/v1/collections/all': { title: 'US National Agriculture Imagery Program' },
            '/external/usda-fasgis.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA FAS GIS Hub' },
            '/external/usda-snap-retailers-usda-fns.hub.arcgis.com/api/search/v1/collections/all': { title: 'USDA SNAP Retailers' },
            '/external/nps-fuels-treatments-nifc.hub.arcgis.com/api/search/v1/collections/all': { title: 'US National Park Service Fuels Treatments' },
            '/external/wildfireapps-nifc.hub.arcgis.com/api/search/v1/collections/all': { title: 'US National Interagency Fire Center Wildfire Apps' },
            '/external/federal-lands-recreation-enhancement-act-hub-usfs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USFS Federal Lands Recreation Enhancement Act' },
            '/external/gis-fema.hub.arcgis.com/pages/usa-structures/api/search/v1/collections/all': { title: 'US Federal Emergency Management Agency' },
            '/external/hepgis-usdot.hub.arcgis.com/api/search/v1/collections/all': { title: 'US Department of Transportation HEPGIS' },
            '/external/gbp-blm-egis.hub.arcgis.com/api/search/v1/collections/all': { title: 'US Bureau of Land Management Geospatial Business Platform' },
            '/external/public-data-hub-dhhs.hub.arcgis.com/api/search/v1/collections/all': { title: 'US Department of Health and Human Services' },
            '/external/usgs.hub.arcgis.com/api/search/v1/collections/all': { title: 'USGS ArcGIS Hub' },
            '/external/gis-usflibrary.hub.arcgis.com/api/search/v1/collections/all': { title: 'University of South Florida' },
            '/external/mapsgislib-pennstate.hub.arcgis.com/api/search/v1/collections/all': { title: 'Penn State University' },
            '/external/nasa.hub.arcgis.com/api/search/v1/collections/all': { title: 'NASA ArcGIS Hub' },
            '/external/noaa.hub.arcgis.com/api/search/v1/collections/all': {
                title: 'NOAA GeoPlatform Hub',
                description: 'NOAA ArcGIS Online'
            }
        };

        return (stac, state) => {
            const path = stac.getBrowserPath();
            const metadata = stacMetadata[path];
            if (metadata) {
                Object.assign(stac, metadata);
            }
            return stac;
        };
    })()
};
